<template>
  <b-overlay :show="showLoading" rounded="sm">
    <h4>訂單管理</h4>

    <div class="row mx-0 justify-content-between mb-2 mt-3">
      <div>
        <b-button v-b-toggle="['collapse-filter', 'collapse-search']" variant="outline-info">
          <span class="mdi mdi-magnify"></span>進階搜尋
        </b-button>
      </div>
      <div v-if="showFilter">
        <b-button
          v-if="$permissions.has($permissions.consts.ORDER_TO_POINT_CALCULATE)"
          class="mr-2"
          variant="inverse-info"
          @click="handleOrderToPointCalculateButtonClicked"
          :disabled="isConvertingOrderToPoints"
        >
          <b-spinner v-if="isConvertingOrderToPoints" class="mr-1" small></b-spinner>
          <span v-else class="mdi mdi-cloud-upload mr-1"></span>訂單給點即時運算
        </b-button>
        <span v-if="$permissions.hasAny([$permissions.consts.ORDER_IMPORT_LIGHT, $permissions.consts.ORDER_IMPORT])"
          class="mr-2">
          <b-button
            variant="inverse-info"
            :to="{
              name: 'OrderImport',
              query: { merchant_id: this.query.merchant_id },
            }"
            :disabled="query.merchant_id === null || query.merchant_id === 'null'"
          >
            <span class="mdi mdi-cloud-upload mr-1"></span>批次上傳
          </b-button>
        </span>
<!--        <span v-if="$permissions.has($permissions.consts.ORDER_IMPORT)"-->
<!--          class="mr-2">-->
<!--          <b-button-->
<!--            v-b-modal.modal-upload-->
<!--            variant="inverse-info"-->
<!--            :disabled="query.merchant_id === null || query.merchant_id === 'null'"-->
<!--          >-->
<!--            <span class="mdi mdi-cloud-upload mr-1"></span>訂單匯入-->
<!--          </b-button>-->
<!--        </span>-->
        <b-dropdown text="匯出" variant="primary" class="mr-2">
          <b-dropdown-item @click="listExport">清單匯出</b-dropdown-item>
          <b-dropdown-item @click="detailExport">明細匯出</b-dropdown-item>
        </b-dropdown>
        <b-button
          v-if="$permissions.has($permissions.consts.ORDER_CREATE)"
          variant="primary"
          :disabled="query.merchant_id === null || query.merchant_id === 'null'"
          :to="{
            name: 'OrderCreate',
            query: { merchant_id: this.query.merchant_id },
          }"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>新增訂單
        </b-button>
      </div>
    </div>

    <b-collapse id="collapse-filter" class="mt-2">
      <b-card>
        <b-form inline>
          <b-form-group
            v-if="!showFilter"
            label="通路名稱"
            class="mr-2 mb-2"
          >
            <b-form-select
              v-model="query.merchant_id"
              :options="merchants"
              @change="handleMerchantIdChange"
              :disabled="merchants.length == 2"
              v-if="!showFilter"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="showFilter"
            label="通路名稱"
            class="mr-2 mb-2"
          >
            <b-form-select
              v-model="query.merchant_id"
              :options="merchants"
              @change="handleMerchantIdChange"
              :disabled="merchants.length == 2"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-card>
    </b-collapse>

     <b-collapse id="collapse-search" class="mt-2" v-if="showFilter">
      <b-card>
        <b-input-group>
          <b-form-input
            placeholder="訂單編號或外部編號"
            v-model="query.keyword"
            v-on:keyup.enter="handlePageReset"
            style="max-width: 500px;"
          ></b-form-input>
          <b-input-group-append>
            <b-button @click="handlePageReset"
              ><i class="fa fa-search"></i
            ></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-card>
    </b-collapse>

    <b-table
      responsive
      striped
      hover
      :items="orders"
      :fields="filteredFields"
      @sort-changed="handleSort"
    >
      <template #cell(branch)="data">
        {{
          data.item.branch ? data.item.branch.name / data.item.branch.id : ""
        }}
      </template>

      <template #cell(order_number)="data">
        <router-link
          :to="{
            name: 'OrderDetail',
            params: {
              order_id: data.item.id,
            },
          }"
        >
          {{ data.item.order_number }}
        </router-link>
      </template>
      <template #cell(outer_order_number)="data">
        <router-link
          :to="{
            name: 'OrderDetail',
            params: {
              order_id: data.item.id,
            },
          }"
        >
          {{ data.item.outer_order_number }}
        </router-link>
      </template>
      <template #cell(customer_name)="data">
        <div v-if="data.item.customer" class="d-flex align-items-center">
          <router-link
            :to="{
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.customer.id,
              },
            }"
            class="mr-1"
          >
            {{ data.item.customer.name }}
          </router-link>
          <span
            class="mdi mdi-account-search"
            style="cursor: pointer; font-size: 1.2rem; color: #007bff; line-height: 1;"
            :id="`popover-customer-${data.item.id}`"
            @click="openCustomerInfoModal(data.item.customer)"
          ></span>
          <b-popover
            :target="`popover-customer-${data.item.id}`"
            triggers="hover focus"
          >
            <div class="text-left">點擊，檢視會員資料及綁定狀況</div>
          </b-popover>
        </div>
        <span v-else>-</span>
      </template>
      <template #cell(memo)="data">
        <div class="d-flex flex-column align-items-center">
          <span
            v-if="data.item.memo"
            v-b-modal.modal-memo-view
            class="mdi mdi-tag-text-outline mr-1"
            style="cursor: pointer; font-size: 1rem;"
            :id="`popover-memo-${data.item.id}`"
            @click="modalTitle = '消費備註', modalContent = data.item.memo"
          ></span>
          <b-popover
            v-if="data.item.memo"
            :target="`popover-memo-${data.item.id}`"
            triggers="hover focus"
          >
            <div class="text-left">點擊，觀看『消費備註』</div>
          </b-popover>

          <span
            v-if="data.item.processed_memo"
            v-b-modal.modal-memo-view
            class="mdi mdi-coin"
            style="cursor: pointer; font-size: 1rem;"
            :id="`popover-points-${data.item.id}`"
            @click="modalTitle = '入點說明', modalContent = data.item.processed_memo"
          ></span>
          <b-popover
            v-if="data.item.processed_memo"
            :target="`popover-points-${data.item.id}`"
            triggers="hover focus"
          >
            <div class="text-left">點擊，觀看『入點說明』</div>
          </b-popover>
        </div>
      </template>
      <template #cell(action)="data">
        <b-dropdown
          v-if="(checkPermission([consts.ORDER_ASSIGN_CUSTOMER]) && !upperCustomerId) || checkPermission([consts.ORDER_POINT_DELETE])"
          class="ml-2"
          size="sm"
          variant="inverse-secondary"
        >
          <template slot="button-content">
            <i class="mdi mdi-menu"></i>
          </template>
          <b-dropdown-item
            v-if="checkPermission([consts.ORDER_ASSIGN_CUSTOMER]) && !upperCustomerId"
            @click="openAssignCustomerModal(data.item)"
          >
            訂單歸戶
          </b-dropdown-item>
          <span
            v-if="checkPermission([consts.ORDER_POINT_DELETE])"
            :id="`delete-points-tooltip-${data.item.id}`"
          >
            <b-dropdown-item
              @click="handleDeleteOrderPoints(data.item)"
              :disabled="!data.item.reward_points_earned_customer_id"
            >
              刪除點數紀錄
            </b-dropdown-item>
          </span>
          <b-tooltip
            v-if="checkPermission([consts.ORDER_POINT_DELETE]) && !data.item.reward_points_earned_customer_id"
            :target="`delete-points-tooltip-${data.item.id}`"
            triggers="hover"
          >
            此訂單沒有入點會員資料
          </b-tooltip>
        </b-dropdown>
        <b-button
          class="ml-2"
          variant="inverse-primary"
          v-if="checkPermission([consts.ORDER_LIST_VIEW]) && !upperCustomerId"
          :to="{
            name: 'OrderDetail',
            params: {
              order_id: data.item.id,
            },
          }"
          ><span class="mdi mdi-eye mr-1"></span>查看
        </b-button>
        <b-button
          class="ml-2"
          variant="inverse-warning"
          v-if="checkPermission([consts.ORDER_MODIFY]) && !upperCustomerId"
          :to="{
            name: 'OrderEdit',
            params: {
              order_id: data.item.id
            },
          }"
          ><span class="mdi mdi-lead-pencil mr-1"></span>編輯
        </b-button>
        <b-button
          class="ml-2"
          variant="inverse-danger"
          @click="handleDelete(data.item.id)"
          v-if="checkPermission([consts.ORDER_DELETE]) && !upperCustomerId"
          ><span class="mdi mdi-delete mr-1"></span>刪除
        </b-button>
      </template>
    </b-table>
    <CustomPagination
      :currentPage="query.page"
      :totalRows="totalRows"
      :perPage="query.per_page"
      @page-change="handlePageChange"
      @per-page-change="handlePerPageChange"
    />
    <b-modal id="modal-upload" title="批次上傳-標準" @hidden="resetUploadModal">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">選擇通路</label>
          <b-form-select
            v-model="query.merchant_id"
            :options="merchants"
            disabled
          ></b-form-select>
        </div>
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳 Excel 檔案</label>
          <b-form-file plain v-model="uploadFileComplex" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
        <div class="form-group">
          <b-form-checkbox v-model="autoGenerateMember">
            <span class="text-danger">無會員編號，自動建立會員編號</span>
          </b-form-checkbox>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="
              getSampleExcelFile(
                getModuleConfig('order', 'sample_file.order_import_xls'),
                '/excel/order_standard_list.xlsx'
              )
            "
            ><i class="fa fa-file-text"></i>下載範例檔案</b-button>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          size="sm"
          @click="cancel()">
          關閉
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="mr-2"
          :disabled="!uploadFileComplex || showLoadingUpload"
          @click="uploadOrderWithComplexSchema">
          <b-spinner v-if="showLoadingUpload" small class="mr-1"></b-spinner>
          送出
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-upload-simplified" title="批次上傳-精簡" @hidden="resetUploadModal">
      <b-overlay :show="showLoadingUpload">
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">選擇通路</label>
          <b-form-select
            v-model="query.merchant_id"
            :options="merchants"
            disabled
          ></b-form-select>
        </div>
        <div class="form-group">
          <label class="flex-shrink-0 mr-2 mb-0">請上傳 Excel 檔案</label>
          <b-form-file plain v-model="uploadFileSimplified" placeholder="尚未選擇檔案" browse-text="瀏覽"></b-form-file>
        </div>
        <div class="form-group">
          <b-form-checkbox v-model="autoGenerateMember">
            <span class="text-danger">無會員編號，自動建立會員編號</span>
          </b-form-checkbox>
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="
              getSampleExcelFile(
                getModuleConfig('order', 'sample_file.order_import_light_xls'),
                '/excel/order_simple_list.xlsx'
              )
            "
            ><i class="fa fa-file-text"></i>下載範例檔案</b-button>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          size="sm"
          @click="cancel()">
          關閉
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          class="mr-2"
          :disabled="!uploadFileSimplified || showLoadingUpload"
          @click="uploadOrderWithSimplifiedSchema">
          <b-spinner v-if="showLoadingUpload" small class="mr-1"></b-spinner>
          送出
        </b-button>
      </template>
    </b-modal>

    <!-- Customer Assignment Modal -->
    <StaffAddCustomer
      ref="assignCustomerModal"
      :show-btn="false"
      :can-select="false"
      :source-type="selectedOrder ? getOrderMerchantType(selectedOrder) : 'line'"
      title="訂單歸戶"
      @bind="handleCustomerSelected"
    />

    <!-- Memo View Modal -->
    <b-modal id="modal-memo-view" :title="modalTitle">
      <div class="p-3" style="white-space: pre-wrap; max-height: 400px; overflow-y: auto;">{{ modalContent }}</div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>

    <!-- Customer Info Modal -->
    <b-modal id="modal-customer-info" size="md" @hidden="resetCustomerModal">
      <template #modal-header>
        <h5 class="modal-title">
          <router-link
            v-if="selectedCustomer"
            :to="{
              name: 'CustomerDetailView',
              params: { customerID: selectedCustomer.id },
            }"
            style="text-decoration: none;"
            class="hover-underline"
          >
            會員資料
          </router-link>
        </h5>
        <button type="button" class="close" @click="$bvModal.hide('modal-customer-info')">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <b-overlay :show="showLoadingModal" rounded="sm">
        <div v-if="selectedCustomer" class="p-3" style="max-height: 500px; overflow-y: auto;">
          <!-- Main Customer -->
          <div class="mb-3">
            <CustomerInfoCard :customer="selectedCustomer" />
          </div>

          <!-- Binding Customers -->
          <div v-if="bindingCustomers.length > 0" class="mt-4">
            <hr />
            <h6 class="mb-3">
              <i class="mdi mdi-link-variant mr-2"></i>綁定會員
            </h6>
            <div v-for="customer in bindingCustomers" :key="customer.id" class="mb-4">
              <CustomerInfoCard :customer="customer" :compact="true" />
            </div>
          </div>
        </div>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          @click="cancel()"
        >
          關閉
        </b-button>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { format } from "date-fns";
import orderApi from "@/apis/order";
import excelApi from "@/apis/excel";
import merchantApi from "@/apis/merchant";
import customerApi from "@/apis/customer";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import StaffAddCustomer from "@/pages/Dashboard/Staff/StaffAddCustomer.vue";
import CustomerInfoCard from "@/components/Dashboard/Customer/CustomerInfoCard.vue";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import { getSampleExcelFile } from "@/utils/dashboardUtils";
import { paginationMixin } from "@/mixins/pagination";

export default {
  mixins: [paginationMixin],
  components: { CustomPagination, StaffAddCustomer, CustomerInfoCard },
  props: {
    showFilter: {
      type: Boolean,
      default: true,
    },
    excludeFields: {
      type: Array,
      default: () => [],
    },
    upperCustomerId: {
      type: [Number, String],
      default: null,
    },
    upperMerchantId: {
      type: [String],
      default: null,
    },
    withRelatedOrders: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      consts,
      showLoading: false,
      merchants: [{ value: null, text: "全部" }],
      totalRows: 0,
      showLoadingUpload: false,
      fields: [
        {
          key: "order_number",
          label: "訂單編號",
          sortable: true,
        },
        {
          key: "outer_order_number",
          label: "外部編號",
          sortable: true,
        },
        {
          key: "customer_name",
          label: "顧客姓名",
        },
        {
          key: "total",
          label: "總價(含稅)",
        },
        {
          key: "memo",
          label: "其他說明",
        },
        {
          key: "order_at",
          label: "下單時間",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return format(new Date(value), "yyyy-MM-dd HH:mm");
            }
            return "";
          },
        },
        {
          key: "status_at",
          label: "最新狀態時間",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return format(new Date(value), "yyyy-MM-dd HH:mm");
            }
            return "";
          },
        },
        {
          key: "merchant_name",
          label: "通路名稱",
        },
        {
          key: "action",
          label: "管理",
        }
      ],
      orders: [],
      permissionChecker: new PermissionChecker(),
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        keyword: "",
        sort_by: "order_at",
        order_by: "desc",
        merchant_id: null,
      },
      isConvertingOrderToPoints: false,
      selectedOrder: null,
      selectedCustomer: null,
      bindingCustomers: [],
      showLoadingModal: false,
      autoGenerateMember: false,
      uploadFileComplex: null,
      uploadFileSimplified: null,
      modalTitle: null,
      modalContent: null,
      exportDetail: false,
    };
  },
  computed: {
    filteredFields() {
      return this.fields.filter(
        (field) => !this.excludeFields.includes(field.key)
      );
    },
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchOrders();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  mounted() {
    this.fetchMerchants();
    this.initialized = true;
    this.checkAndExpandAdvancedSearch();
  },
  methods: {
    checkAndExpandAdvancedSearch() {
      // 當網址有查詢參數時，自動展開進階搜尋
      const hasQueryParams = Object.keys(this.$route.query).length > 0;
      if (hasQueryParams) {
        this.$nextTick(() => {
          this.$root.$emit('bv::toggle::collapse', 'collapse-filter');
          this.$root.$emit('bv::toggle::collapse', 'collapse-search');
        });
      }
    },
    getSampleExcelFile,
    async handleOrderToPointCalculateButtonClicked() {
      this.isConvertingOrderToPoints = true;
      try {
        await orderApi.convertOrderToPoints();
        this.$swal.fire({
          title: "轉換完成",
          type: "success",
        });
      } catch (e) {
        console.error(e);
        this.$swal.fire({
          title: "轉換失敗",
          type: "error",
        });
      } finally {
        this.isConvertingOrderToPoints = false;
      }
    },
    async uploadOrderWithComplexSchema() {
      this.showLoadingUpload = true;
      try {
        const response = await excelApi.import('order_complex', this.uploadFileComplex, {
          merchant_id: this.query.merchant_id,
          auto_generate_member: this.autoGenerateMember,
        });
        const stats = response.data?.stats || {};
        const lines = [];
        if (stats.order_insert > 0) lines.push(`新增_訂單資料：${stats.order_insert} 筆`);
        if (stats.order_update > 0) lines.push(`更新_訂單資料：${stats.order_update} 筆`);
        if (stats.order_item_insert > 0) lines.push(`新增_訂單明細：${stats.order_item_insert} 筆`);
        if (stats.order_item_update > 0) lines.push(`更新_訂單明細：${stats.order_item_update} 筆`);
        if (stats.total_fail > 0) lines.push(`<span style="color: red;">失敗：${stats.total_fail} 筆</span>`);
        const resultHtml = `<div style="text-align: center; font-size: 14px;">${lines.join('<br>')}</div>`;
        this.$swal.fire({
          title: "訂單已上傳",
          html: resultHtml,
          type: stats.total_fail > 0 ? "warning" : "success",
        });

        this.query.page = 1;
        await this.fetchOrders();
      } catch (e) {
        console.error(e);
        if (e.response.status === 422 && e.response.data.message) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-upload");
      }
    },
    async uploadOrderWithSimplifiedSchema() {
      this.showLoadingUpload = true;
      try {
        const response = await excelApi.import('order_simplified', this.uploadFileSimplified, {
          merchant_id: this.query.merchant_id,
          auto_generate_member: this.autoGenerateMember,
        });
        const stats = response.data?.stats || {};
        const lines = [];
        if (stats.order_insert > 0) lines.push(`新增_訂單資料：${stats.order_insert} 筆`);
        if (stats.order_update > 0) lines.push(`更新_訂單資料：${stats.order_update} 筆`);
        if (stats.order_item_insert > 0) lines.push(`新增_訂單明細：${stats.order_item_insert} 筆`);
        if (stats.order_item_update > 0) lines.push(`更新_訂單明細：${stats.order_item_update} 筆`);
        if (stats.total_fail > 0) lines.push(`<span style="color: red;">失敗：${stats.total_fail} 筆</span>`);
        const resultHtml = `<div style="text-align: center; font-size: 14px;">${lines.join('<br>')}</div>`;
        this.$swal.fire({
          title: "訂單已上傳",
          html: resultHtml,
          type: stats.total_fail > 0 ? "warning" : "success",
        });

        this.query.page = 1;
        await this.fetchOrders();
      } catch (e) {
        console.error(e);
        if (e.response.status === 422 && e.response.data.message) {
          this.$swal.fire({
            title: "檔案內容有誤",
            type: "error",
            text: e.response.data.message ?? null,
          });
        } else {
          this.$swal.fire({
            title: "上傳失敗",
            type: "error",
          });
        }
      } finally {
        this.showLoadingUpload = false;
        this.$bvModal.hide("modal-upload-simplified");
      }
    },
    async fetchOrders() {
      this.showLoading = true;

      try {
        const params = { ...this.query };
        if (this.upperCustomerId) params.customer_id = this.upperCustomerId;
        if (this.withRelatedOrders) params.with_related_orders = true;

        console.log(params, params.merchant_id);
        // 搜尋前將 字串null(全部) 轉為真正的null
        if (typeof params.merchant_id !=='undefined' && params.merchant_id === 'null'){
          params.merchant_id = null;
        }

        const { data } = await orderApi.getOrders(params);

        this.orders = data.data;
        this.totalRows = data.meta.total;
      } catch (error) {
        console.error(error);
        alert("取得訂單資料錯誤");
      }
      this.showLoading = false;
    },
    async handleMerchantIdChange() {
      // 暫時關閉 watcher，避免 updateUrl 被呼叫導致路由更新（父組件重整）
      const prevInitialized = this.initialized;
      this.initialized = false;

      try {
        this.query.page = 1;
        this.handlePageResetWithoutReload();
        await this.fetchOrders();
      } finally {
        // 恢復 initialized，但不強制觸發 updateUrl（避免父層被重整）
        this.initialized = prevInitialized;
      }
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      // Store full merchant objects for later use

      this.merchants = [
        { value: "null", text: "全部" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
            type: merchant.type
          };
        }),
      ];

      if (!this.query.merchant_id && this.showFilter) {
        const merchants = data.data;
        let defaultMerchant =
          merchants.find(
            (merchant) => merchant.type === this.defaultMerchantType
          ) ?? merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);

        if (defaultMerchant) {
          this.query.merchant_id = defaultMerchant.id;
        }
      }

      if (this.upperMerchantId) {
        this.query.merchant_id = this.upperMerchantId;
      }

      if (this.query.merchant_id) {
        const hasMerchant = this.merchants.find(
          (item) => item.value === this.query.merchant_id
        );
        if (!hasMerchant) {
          this.$swal.fire({
            icon: "warning",
            title: "查無此通路",
            confirmButtonText: "確定",
            confirmButtonColor: "#d33",
            reverseButtons: true,
          });
          return;
        }
      }

      await this.fetchOrders();
    },
    async handleDelete(id) {
      this.$swal
        .fire({
          type: "warning",
          title: "你確定要刪除嗎？",
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              const response = await orderApi.deleteOrder(id);
              if (response.status === 200) {
                await this.$swal.fire({
                  title: "成功",
                  type: "success",
                  text: "刪除成功",
                });
                await this.fetchOrders();
              }
            } catch (error) {
              this.$swal("失敗", error.response.data.message, "error");
            }
          }
        });
    },
    async handleDeleteOrderPoints(order) {
      this.$swal
        .fire({
          type: "warning",
          title: "確定要刪除訂單點數",
          text: `訂單總價：NT$ ${order.total}`,
          confirmButtonText: "確定刪除",
          cancelButtonText: "取消",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            try {
              const response = await orderApi.deleteOrderPoints(order.id);
              if (response.status === 200) {
                await this.$swal.fire({
                  title: "成功",
                  type: "success",
                  text: "點數紀錄刪除成功",
                });
                await this.fetchOrders();
              }
            } catch (error) {
              this.$swal("失敗", error.response?.data?.message || "刪除失敗", "error");
            }
          }
        });
    },
    getOrderMerchantType(order) {
      const merchant = this.merchants.find(m => m.value === order.merchant_id);
      return merchant ? merchant.type.toLowerCase() : 'line';
    },
    openAssignCustomerModal(order) {
      this.selectedOrder = order;
      this.$refs.assignCustomerModal.showModal();
    },
    async handleCustomerSelected(customer) {
      try {
        await orderApi.assignCustomer(this.selectedOrder.id, customer.id);

        this.$swal.fire({
          icon: "success",
          title: "成功",
          text: `已將訂單 ${this.selectedOrder.order_number} 歸戶至會員 ${customer.name}`,
        });

        // Refresh orders list
        await this.fetchOrders();
        this.selectedOrder = null;
      } catch (error) {
        console.error("Error assigning customer:", error);
        this.$swal.fire({
          icon: "error",
          title: "失敗",
          text: error.response?.data?.message || "訂單歸戶失敗，請稍後再試",
        });
      }
    },
    resetUploadModal() {
      this.autoGenerateMember = false;
      this.uploadFileComplex = null;
      this.uploadFileSimplified = null;
    },
    resetAutoGenerateMember() {
      this.autoGenerateMember = false;
    },
    async openCustomerInfoModal(customer) {
      this.selectedCustomer = customer;
      this.bindingCustomers = [];

      // Fetch binding customers
      await this.fetchBindingCustomers(customer.id);

      this.$bvModal.show('modal-customer-info');
    },
    async fetchBindingCustomers(customerId) {
      try {
        this.showLoadingModal = true;
        const { data } = await customerApi.getSameUserCustomers(customerId);
        this.bindingCustomers = data.data.filter((x) => x.id !== customerId);
        this.bindingCustomers.forEach((customer) => {
          if (!customer.merchant_type_name) {
            customer.merchant_type_name = {};
          }
        });
        this.selectedCustomer.merchant_type_name = data.data.find((x) => x.id === customerId).merchant_type_name;
      } catch (error) {
        console.error('Error fetching binding customers:', error);
      } finally {
        this.showLoadingModal = false;
      }
    },
    resetCustomerModal() {
      this.selectedCustomer = null;
      this.bindingCustomers = [];
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.handlePageResetWithoutReload();
      this.fetchOrders();
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
    },
    listExport() {
      this.exportDetail = false;
      this.handleExport();
    },
    detailExport() {
      this.exportDetail = true;
      this.handleExport();
    },
    async handleExport() {
      try {
        this.showLoading = true;

        const params = {
          export_detail: this.exportDetail,
          merchant_id: this.query.merchant_id !== 'null' ? this.query.merchant_id : null,
          keyword: this.query.keyword || null,
          sort_by: this.query.sort_by,
          order_by: this.query.order_by,
        };

        await orderApi.exportOrders(params);

        this.$swal({
          title: "成功",
          text: "可至「我的主控台」查看紀錄及下載檔案",
          showCancelButton: true,
          cancelButtonText: "確認",
          type: "success",
          confirmButtonText: "前往查看",
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: "MyConsoleDownloadFileList",
              params: { org_code: this.$route.params.org_code },
            });
          }
        });
      } catch (error) {
        console.error(error);
        this.$swal("錯誤", "匯出失敗", "error");
      } finally {
        this.showLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  opacity: 0.5;
}

.hover-underline {
  color: #007bff;
  transition: all 0.2s ease;
}

.hover-underline:hover {
  color: #0056b3;
  text-decoration: underline !important;
}
</style>
